<!--
     <Rain
       :entries="my_entries"
       :title="my_title"
       :start_date="2022-07-30"
     />

     entries: [[9.8, 177.9], [10.1, 177.2]]
-->


<template>
  <highcharts
    class="hc"
    :options="chartOptions"
    ref="chart"
  >
  </highcharts>
</template>

<script>
 /* import utils from '@/utils'
  */
 export default {
   name: 'Rain',

   props: [
     'entries',
     'title',
     'start_date',
     'precision',
   ],

   data: (() => ({
   })),

   computed: {
     chartOptions() {
       return {
         title: {
           text: this.title
         },

         chart: {
           type: 'column',
           backgroundColor: 'transparent',
         },

         credits: {
           enabled: false
         },

         yAxis: {
           min: 0,
           title: {
             text: 'Pluja en mm'
           }
         },

         xAxis: {
           type: 'datetime',
           title: {
             rotation: -45,
             /* text: 'Data' */
           },
         },

         plotOptions: {
           series: {
             label: {
               connectorAllowed: false
             },
             pointStart: this.start_date,
             pointInterval: this.precision,
           }
         },

         legend: {
           enabled: false
         },

         tooltip: {
           pointFormat: 'Pluja total: <b>{point.y:.1f}</b> mm'
         },

         series: [{
           name: 'Pluja',
           data: this.entries,
           color: '#880016',
         }],
       };
     },
   },

   mounted() {
   },

   methods: {
   },
 }
</script>
